<div class="row">
	<div class="col-lg-12">
		<div class="ibox float-e-margins">
			<div class="ibox-content">
				<form name="ActionForm" class="form-horizontal" role="form" novalidate>
					<!--START OPTIONS-->
					<!--SchoolID-->
					<div class="form-group">
						<label class="col-sm-3 col-lg-2 control-label">School</label>
						<div class="col-sm-4 col-lg-3">
							<caass-schoolselector
								[ShowAll]="true"
								[ShowAllID]="SchoolSelectShowAllID"
								[ShowAllText]="SchoolSelectShowAllText"
								[IsReport]="true"
								[ReportID]="454"
							>
							</caass-schoolselector>
						</div>
					</div>

					<!--Grade Level-->
					<div class="form-group">
						<label class="col-sm-3 col-lg-2 control-label">Grade Level</label>
						<div class="col-sm-4 col-lg-3">
							<select class="form-control" name="GradeLevelID" [(ngModel)]="report.GradeLevelID">
								<option value="" style="display: none"></option>
								<option *ngFor="let o of GradeLevelList" [ngValue]="o.GradeLevelID">
									{{ o.GradeLevelDesc }}
								</option>
							</select>
						</div>
					</div>

					<!--Academy-->
					<div class="form-group">
						<label class="col-sm-3 col-lg-2 control-label">Academy</label>
						<div class="col-sm-4 col-lg-3">
							<select class="form-control" name="AcademyID" [(ngModel)]="report.AcademyID">
								<option value="" style="display: none"></option>
								<option *ngFor="let o of AcademyList" [ngValue]="o.AcademyID">
									{{ o.AcademyDesc }}
								</option>
							</select>
						</div>
					</div>

					<!--Homeroom-->
					<div class="form-group">
						<label class="col-sm-3 col-lg-2 control-label">Homeroom</label>
						<div class="col-sm-4 col-lg-3">
							<select class="form-control" name="HomeroomID" [(ngModel)]="report.HomeroomID">
								<option value="" style="display: none"></option>
								<option *ngFor="let o of HomeroomList" [ngValue]="o.HomeroomID">
									{{ o.HomeroomDesc }}
								</option>
							</select>
						</div>
					</div>

					<!--Group-->
					<div class="form-group">
						<label class="col-sm-3 col-lg-2 control-label">Group</label>
						<div class="col-sm-4 col-lg-3">
							<select class="form-control" name="GroupID" [(ngModel)]="report.GroupID">
								<option value="" style="display: none"></option>
								<option *ngFor="let o of GroupList" [ngValue]="o.GroupID">
									{{ o.GroupName }}
								</option>
							</select>
						</div>
					</div>

					<!--Already Signed Up-->
					<div class="form-group">
						<label class="col-sm-3 col-lg-2 control-label">Already Signed Up</label>
						<div class="col-sm-4 col-lg-3">
							<select class="form-control" name="AlreadySignedUpID" [(ngModel)]="report.AlreadySignedUpID">
								<option value="" style="display: none"></option>
								<option *ngFor="let o of AlreadySignedUpList" [ngValue]="o.ID">
									{{ o.Desc }}
								</option>
							</select>
						</div>
					</div>

					<!--SortBy-->
					<div class="form-group">
						<label class="col-sm-3 col-lg-2 control-label">Sort By</label>
						<div class="col-sm-4 col-lg-3">
							<select class="form-control" name="SortBy" [(ngModel)]="report.SortBy">
								<option value="" style="display: none"></option>
								<option *ngFor="let o of SortByList" [ngValue]="o.ID">
									{{ o.Desc }}
								</option>
							</select>
						</div>
					</div>

					<!--SortDirection-->
					<div class="form-group">
						<label class="col-sm-3 col-lg-2 control-label">Sort Direction</label>
						<div class="col-sm-4 col-lg-3">
							<select class="form-control" name="SortDirection" [(ngModel)]="report.SortDirection">
								<option value="" style="display: none"></option>
								<option *ngFor="let o of SortDirectionList" [ngValue]="o.ID">
									{{ o.Desc }}
								</option>
							</select>
						</div>
					</div>

					<!--ImageLogo-->
					<div class="form-group">
						<label class="col-sm-3 col-lg-2 control-label">Logo</label>
						<div class="col-sm-4 col-lg-3">
							<select class="form-control" name="ImageLogo" [(ngModel)]="report.ImageLogo">
								<option value="" style="display: none"></option>
								<option *ngFor="let o of ImageLogoList" [ngValue]="o.ImageLibraryID">
									{{ o.LogoDesc }}
								</option>
							</select>
						</div>
					</div>

					<!--File Type-->
					<div class="form-group">
						<label class="col-sm-3 col-lg-2 control-label">Output File Type</label>
						<div class="col-sm-4 col-lg-3">
							<select class="form-control" name="OutputTypeID" [(ngModel)]="OutputTypeID">
								<option value="" style="display: none"></option>
								<option *ngFor="let o of OutputTypeList" [ngValue]="o.ID">
									{{ o.Desc }}
								</option>
							</select>
						</div>
					</div>

					<!--Submit Form-->
					<div class="hr-line-dashed"></div>
					<div class="form-group">
						<div name="errorMessage" *ngIf="errorMessage" class="alert alert-danger">
							{{ errorMessage }}
						</div>
					</div>
					<div class="form-group">
						<label class="col-sm-3 col-lg-2 control-label"></label>
						<div class="col-md-4 col-lg-3">
							<div name="Saveing" *ngIf="isProcessing" class="alert alert-info">Processing.Please wait...</div>
							<button name="btnSaving" *ngIf="!isProcessing" class="btn btn-primary" type="button" (click)="Print()">Print</button>
							<button
								name="btnMerge"
								*ngIf="!isProcessing"
								class="btn btn-primary"
								style="margin-left: 5px"
								type="button"
								(click)="MergeToGroup()"
							>
								Merge to Group
							</button>
						</div>
					</div>
				</form>
			</div>
		</div>
	</div>
</div>
